// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2045":"249dbc57","2486":"dfee3d70","4029":"dfee3d70","4480":"dfee3d70"}[chunkId] + ".chunk.css";
};